<template>
  <div class="zy-container">
    <div class="zy-header  flex-center">
      
      <div class="title">{{queryData.name}}</div>
      <div class="zy-basic-container flex-center">
        <div
          class="zy-basic-info flex-center"
          v-for="(item, index) in basicList"
          :key="index"
        >
          <el-tag class="zy-tag" type="primary"> {{ item.name }} </el-tag>
          <div>{{ item.value }}</div>
        </div>
      </div>
      <div class="school" @click="gofn">查看开设院校</div>
    </div>

    <div class="zy-content">
      <div class="zy-content-item">
        <div>
          <div class="link-left">
            <span style="margin-left: 10px">专业介绍</span>
          </div>
          <el-divider></el-divider>
        </div>
        <div class="zy-content-info">
          {{zyinfo.zyjs}}
        </div>
      </div>
      <div class="zy-content-item">
        <div>
          <div class="link-left">
            <span style="margin-left: 10px">相近专业</span>
          </div>
          <el-divider> </el-divider>
        </div>
        <div class="zy-content-info">
            {{zyinfo.xjzy}}
        </div>
      </div>
      <div class="zy-content-item">
        <div>
          <div class="link-left">
            <span style="margin-left: 10px">该专业学生考研方向</span>
          </div>
          <el-divider></el-divider>
        </div>
        <div class="zy-content-info">
          {{zyinfo.zyxskyfx}}
        </div>
      </div>
      <div class="zy-content-item">
        <div>
          <div class="link-left">
            <span style="margin-left: 10px">已毕业人员从业方向</span>
          </div>
          <el-divider></el-divider>
        </div>
        <div class="zy-content-info">
          {{zyinfo.byrycyfx}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import category from "../../../../api/adaptation.js";

export default {
  name: 'zy',
  data() {
    return {
      queryData: this.$route.query,
      basicList: [
        {
          name: '学历层次',
          value: ''
        }, {
          name: '专业代码',
          value: ''
        }, {
          name: '门类',
          value: ''
        }, {
          name: '专业类',
          value: ''
        }
      ],
      zyinfo: {}
    };
  },

  components: {},

  created() {
    this.getProfessionDetail()
    console.log(this.$route.query)
  },
  methods: {
    init() {
      this.basicList[0]['value'] = this.zyinfo.xlcc
      this.basicList[1]['value'] = this.zyinfo.zydm
      this.basicList[2]['value'] = this.zyinfo.zymc
      this.basicList[3]['value'] = this.zyinfo.zyl
    },
    getProfessionDetail() {
      category.getProfessionDetailByCode(this.queryData.code).then((res) => {
        this.zyinfo = res.data
        this.init()
      })
    },
    gofn () {
      this.$router.push({
        path: '/schoollist',
        query: {
          code: this.queryData.code,
          name: this.queryData.name
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.zy-container {
  width: 99vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.flex-center {
  display: flex;
  text-align: center;
}
.zy-header {
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  .school {
    position: absolute;
    top: 25%;
    right: 10%;
    height: 40px;
    // width: 100px;
    background: #0b56b0;
    color: #fff;
    border-radius: 10px;
    line-height: 40px;
    padding: 0 20px;
    cursor: pointer;
  }
  .back {
    position: absolute;
    left: 0;
    top: 35%;
  }
  .school:hover{
  box-shadow: -2px 0px 5px 1px #e7ebf0, 0px -2px 5px 1px #e7ebf0,
    2px 0px 5px 1px #e7ebf0, 0px 2px 5px 1px #e7ebf0;
  }
}
.title {
  margin: 30px 0 50px 0;
  font-size: 40px;
}
.zy-basic-container {
  flex-direction: row;
  justify-content: space-between;
}
.zy-basic-info {
  align-items: center;
}
.zy-tag {
  margin-right: 20px;
}

.zy-content {
  margin-top: 50px;
  width: 60%;
}
.link-left {
  border-left: solid #0b56b0 3px;
}
.zy-content-info {
  padding: 0 10px;
  font-size: 16px;
  line-height: 32px;
}
.zy-content-item {
  margin-bottom: 55px;
}
</style>